module.exports = __webpack_public_path__ + "static/media/person1.60eac4f0.png";